import { NgModule } from '@angular/core';
import { DateFilterPipe } from './dateFilter.pipe';
import { FilterPipe } from './filter.pipe';
import { HoursPipe } from './hours.pipe';
import { SafePipe } from './safe.pipe';
import { StatusFilterPipe } from './statusFilter.pipe';
import { timeFilterPipe } from './timeFilter.pipe';
import { TruncatePipe } from './truncate.pipe';
import { CustomMonthFormatPipe } from './custom-month-format-pipe';

@NgModule({
  declarations: [FilterPipe, SafePipe, TruncatePipe, StatusFilterPipe, DateFilterPipe, timeFilterPipe,HoursPipe,CustomMonthFormatPipe ],
  exports: [ FilterPipe, SafePipe, TruncatePipe, StatusFilterPipe, DateFilterPipe, timeFilterPipe, HoursPipe,CustomMonthFormatPipe]
})
export class FilterPipeModule { }
